module.exports = __webpack_public_path__ + "static/media/Shenzu Spending.3313a995.png";